import React, { Component } from "react";

import nome from "../../../../img/landing-page/nome.svg";
import telefone from "../../../../img/landing-page/telefone.svg";
import email from "../../../../img/landing-page/email.svg";
import axios from "axios";
import Loading from "../../../../shared/Loading/Loading.js";
import Form from "../../../../shared/Form/Form";
import PubSub from "pubsub-js";
import "../../../../../js/shared/pubsub-triggers";
import md5 from "blueimp-md5";

import { offersWhiteColor } from '../../../../shared/variables';

class LandingPageForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			errorMessage: '',
			errors: [],
			data: {
				name: "",
				email: "",
				phone: "",
				lp: "offers-landing-page"
			},
			submitted: false
		};
	}

	handleSubmit(formResponse) {
		if (!formResponse.isValid) {
			this.setState({ errors: formResponse.errors });
			return;
		}

		this.setState(
			{
				isLoading: true,
				errors: {}
			},
			() =>
				axios
					.post("https://api-small-suppliers.maxmilhas.com.br/suppliers", this.state.data)
					.then(response => {

                        const email = this.state.data.email;

                        PubSub.publish("dataLayer", {
                            event: "gaEvent",
                            gaEventCategory: "LP quero vender milhas",
                            gaEventAction: "Sucesso",
                            gaEventLabel: this.props.gaEventLabel
                        });

                        PubSub.publish("dataLayer", {
                            event: "lpSuccessLeadOffer",
                            lpMail: md5(email)
                        });

                        if (this.props.submitted) {
							return this.props.submitted();
						}

						this.setState({ isLoading: false, submitted: true });

					})
					.catch(error => this.setState({ errorMessage: error.response.data.message, isLoading: false }))
		);
	}

	handleChange(event) {
		let targetName = event.target.name;
		let targetValue = event.target.value;

		this.setState({
			data: {
				...this.state.data,
				[targetName]: targetValue
			}
		});
	}

	render() {
		return (
			<Form
				onChange={event => this.handleChange(event)}
				submit={e => this.handleSubmit(e)}
				className="offers-landing-page-form"
				noValidate
				id={this.props.id}
			>
				{this.state.errorMessage !== '' && <div className="has-error">{ this.state.errorMessage }</div>}
				{!this.state.submitted && !this.props.didSubmitted ? (
					<div>
						<div
							className={`offers-landing-page-form--field-container${
								this.state.errors.name ? " has-error" : ""
							}`}
						>
							<img alt="" src={nome} />
							<input required placeholder="Nome" name="name" value={this.state.data.name} />
							{this.state.errors.name === "valueMissing" && (
								<small>Campo obrigatório. Favor, preencher.</small>
							)}
						</div>
						<div
							className={`offers-landing-page-form--field-container${
								this.state.errors.email ? " has-error" : ""
							}`}
						>
							<img alt="" src={email} />
							<input required placeholder="E-mail" name="email" type="email" />
							{this.state.errors.email === "valueMissing" && (
								<small>Campo obrigatório. Favor, preencher.</small>
							)}
							{this.state.errors.email === "typeMismatch" && (
								<small>E-mail inválido. Por favor, verifique!</small>
							)}
						</div>
						<div
							className={`offers-landing-page-form--field-container${
								this.state.errors.phone ? " has-error" : ""
							}`}
						>
							<img alt="" src={telefone} />
							<input required placeholder="Telefone" name="phone" value={this.state.data.phone} />
							{this.state.errors.phone === "valueMissing" && (
								<small>Campo obrigatório. Favor, preencher.</small>
							)}
						</div>

						<button
							disabled={this.state.isLoading}
							type="submit"
							className={`btn btn-${this.props.buttonColor}-md-s`}
						>
							{this.state.isLoading ? (
								<Loading width={25} height={25} fillColor={offersWhiteColor} />
							) : (
								this.props.buttonText
							)}
						</button>
					</div>
				) : (
					<div className="offers-landing-page-form__message">
						{this.props.message || "Obrigado pelo contato!"}
					</div>
				)}
			</Form>
		);
	}
}

export default LandingPageForm;
